






























	// @ts-ignore
    import _ from './MPopupRequest.ts'; export default _;
